<template>
  <div class="dclass">
    <div v-if="showMLoading" class="mloading-mask">
      <MLoading :config="mLoadingConfig" />
    </div>

    <div :style="{ height: divHei + 'px', padding: '15% 30%' }">
      <div v-if="isNN(jumpLoginErr)">{{ jumpLoginErr }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { addDynamicRoutes } from '@/router';
import { useBriefStore, useSettingStore, useUserStore } from 'd3components';
import { getKeyStr ,removeKey, setKey, setKeyJsonStr ,getKeyJson,updateKeyJson,getsubKey, removeKeys} from 'd3components/src/utils/localStorage';

import { default as mitt } from 'mitt-utils'
import { clearLs,  isMobile, isNN, loginHref, toast } from 'd3components/src/utils/tools';
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MLoading from 'd3components/src/components//item-d3/third/d3_toast.vue';
// import { getPid } from 'd3components/src/components/actionUtils/actionUtil';
import { getPid } from 'exeAction-utils'
// VTable CDN 已移至 index.html 预加载，不再需要动态加载

import { useI18n } from 'vue-i18n';

const settingStore: any = useSettingStore();
const userStore = useUserStore();
const briefStore = useBriefStore;
const { t } = useI18n({ useScope: 'global' });

const router = useRouter();
const route = useRoute();

const divHei = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
const showMLoading = ref(true);
const loadPercent = ref(5);

// m_loading 配置：为 /loading 页面单独指定 pid & did，确保 mittName 不为 null，事件能正确触发
const mPid = getPid(route);
const mLoadingDid = 'loading_m_loading';
const mLoadingMittName = `${mPid}_mitt_did_${mLoadingDid}`;
const mLoadingConfig = { pid: mPid, did: mLoadingDid };

const loadingTip = (step: number) => {
  loadPercent.value = loadPercent.value + step > 100 ? 100 : loadPercent.value + step;
};

onMounted(() => {
  console.log('===== [loading.vue] onMounted START =====');
  // 进入 loading 页面时立即打开全局 loading 遮罩
  mitt.emit(mLoadingMittName, { flg: 'f_open' });
  initData();
});

onUnmounted(() => {
  showMLoading.value = false;
  mitt.emit(mLoadingMittName, { flg: 'f_close' });
});

const initUserSto = () => {
  // isJumpLogin();
  try {
    let kUrl = window.location.href;

    userStore.loginUrl = `${kUrl.split('#')[0]}`;
    console.log('登录地址：', userStore.loginUrl);

    userStore.serUrl = import.meta.env.VITE_BASE_API;
    console.log('登录信息', userStore.serUrl);

    userStore.initUserStore();

    if (!window.indexedDB) {
      console.error('不支持indexDb', 3);
      return;
    }
  } catch (e: any) {
    console.error('loading initUserSto', e);
  }
};

watch(loadPercent, (newVal) => {
  if (newVal >= 100) {
    initTheme();
  }
});
initUserSto();

let jumpLoginErr = ref();

const initData = () => {
  const initializeApp = async () => {
    try {
      await userStore.firstMenuFun();
      loadingTip(5);

      await serviceConfig(userStore.ctxt);
      initTrueTheme();
      loadingTip(5);

      if (isMobile()) {
        settingStore['layout'] = 'drawer';
        settingStore['isUseTabsRouter'] = false;
        settingStore['isSidebarCompact'] = false;
      }

      initRoute();
      await addDynamicRoutes();
      loadingTip(15);

      await briefStore.getIamBrief();
      loadingTip(20);

      await briefStore.getServiceBrief();
      loadingTip(40);

      loadingTip(10);

      // 由 watch(loadPercent>=100) 触发 initTheme（对齐 final/web 的行为）


    } catch (e: any) {
      if (e['info'] && e['info'].includes('鉴权超期')) {
        setKeyJsonStr('auth', e);
        setTimeout(() => {
          showMLoading.value = false;
          router.replace('/loading');
        }, 20);
      } else {
        console.error('login error', e);
        if (e) {
          if (e['response'] && e['response']['status'] > 0) {
            toast(`${e['response']['status']}：${e['response']['statusText']}`, 3);
          } else if (e['code'] === 153) {
            console.log('获取菜单组失败', e);
            userStore.menuTree = [];
            toast(isNN(e['msg']) ? e['msg'] : e['message'] ? e['message'] : e, 3);
            showMLoading.value = false;
            router.replace('/login/');
            return;
          } else {
            toast(isNN(e['msg']) ? e['msg'] : e['message'] ? e['message'] : e, 3);
          }
        }
        clearLs([]);
        setTimeout(() => {
          showMLoading.value = false;
          loginHref('');
        }, 20);
      }
    }
  };

  if (Capacitor.isNativePlatform()) {
    initializeApp()
      .finally(async () => {
        try {
          await SplashScreen.hide({ fadeOutDuration: 150 });
        } catch (err) {
          console.warn('隐藏原生启动页失败', err);
        }
      });
  } else {
    initializeApp();
  }
};

const serviceConfig = async (ctxt: string) => {
  console.log('+++++++ctxt', ctxt);
  if (!ctxt) {
    return;
  }
  try {
    const res = await userStore.loadServiceConfig(ctxt);
    console.log('----> config++++++', res);
  } catch (e: any) {
    console.error(`----> config+++++ ${e}`);
    if (e['response'] && e['response']['status'] > 0) {
      const tMsg = `${e['config']['url']}：${e['response']['status']}-${e['response']['statusText']}`;
      mitt.emit('app_mitt', { flg: 'toast', msg: tMsg, type: 3 });
    } else {
      mitt.emit('app_mitt', { flg: 'toast', msg: e, type: 3 });
    }
  }
};

const initRoute = () => {
  const { firstMenu } = userStore;
  try {
    document.title = firstMenu['groupname'];
  } catch (e) {
    console.log(e);
    // document.title = isJumpLogin() ? '' : t('common.appTitle');
     document.title =  t('common.appTitle');
  }
};

const initTheme = () => {
  console.log('执行到这里', 77777);
  const toAbsPath = (p: any): string | undefined => {
    if (typeof p !== 'string' || !p) return undefined;
    return p.startsWith('/') ? p : `/${p}`;
  };
  const resolveFirstReachable = (node: any): string | undefined => {
    if (!node) return undefined;
    const red = node?.redirect;
    if (typeof red === 'string' && red) return toAbsPath(red) || red;
    if (red && typeof red === 'object') {
      try {
        return router.resolve(red).path;
      } catch {
        // ignore
      }
    }
    const kids = Array.isArray(node?.children) ? node.children : [];
    if (kids.length > 0) return resolveFirstReachable(kids[0]);
    const p = typeof node?.path === 'string' ? node.path : '';
    return toAbsPath(p) || undefined;
  };

  const rq: any = { ...(route.query as any) };
  const redirect = rq?.redirect;
  if (rq && Object.prototype.hasOwnProperty.call(rq, 'redirect')) {
    delete rq.redirect;
  }

  let url: any = '/';
  if (typeof redirect === 'string' && redirect) {
    url = redirect;
  } else {
    const tree = (userStore as any)?.userMenuRouter;
    const first = Array.isArray(tree) ? tree[0] : undefined;
    url = resolveFirstReachable(first) || '/';
  }
  url = toAbsPath(url) || url;

  const doNav = () => {
    console.log('跳转时候参数：', route.query);
    showMLoading.value = false;
    router.replace({ path: url, query: rq });
  };

  if (loadPercent.value < 100) {
    const intv = setInterval(() => {
      loadPercent.value = loadPercent.value + 8 > 100 ? 100 : loadPercent.value + 8;
      if (loadPercent.value >= 100) {
        clearInterval(intv);
        setTimeout(() => doNav(), 10);
      }
    }, 50);
  } else {
    doNav();
  }
};

function initTrueTheme() {
  try {
    settingStore.updateConfig(userStore['erpConfig']);
    console.log('erpconfig++++++', userStore['erpConfig']);
  } catch (e) {
    console.log('初始化合并异常', e);
  }

  try {
    const { serUrl, erpConfig } = userStore;
    const staticSer = serUrl || '';

    if (staticSer) {
      const favPath = (erpConfig as any)?.['s_menu_fav'] || (erpConfig as any)?.fav || '';
      const logosmall = favPath ? `${staticSer}${favPath}` : '';

      console.log('浏览器图标', logosmall);

      if (logosmall) {
        let $favicon: any = document.querySelector('link[rel="icon"]');

        if ($favicon !== null) {
          $favicon.href = logosmall;
        } else {
          $favicon = document.createElement('link');
          $favicon.rel = 'icon';
          $favicon.href = logosmall;
          document.head.appendChild($favicon);
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
}
</script>

<style lang="scss" scoped>
.dclass {
  background-color: #f5f5f5;
}

.mloading-mask {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.35);
}

.mloading-mask :deep(view) {
  display: block;
}

.mloading-mask :deep(.wrapper) {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mloading-mask :deep(.spinner) {
  margin: 0;
}
</style>
